import style from './style.module.scss'
import { lazy, useEffect, useRef, useState } from 'react'

interface PropsPanelProps {
  type: string
  selectedProps?: any
  onUpdate: (newProps: any) => void
}

export const componentControlsRegistry: { [key: string]: React.ElementType } = {}

interface registerControlsComponentProps {
  name: string
  component: React.ElementType
}

export const registerControlsComponents = (components: registerControlsComponentProps[]) => {
  components.forEach((component) => {
    componentControlsRegistry[component.name] = component.component
  })
}

registerControlsComponents([
  {
    name: 'uiImage',
    component: lazy(() =>
      import('../../EditorComponents/uiImage').then((module) => ({ default: module.UiImageControls }))
    )
  },
  {
    name: 'uiParagraph',
    component: lazy(() =>
      import('../../EditorComponents/uiParagraph').then((module) => ({ default: module.UiParagraphControls }))
    )
  },
  {
    name: 'uiSubtitle',
    component: lazy(() =>
      import('../../EditorComponents/uiSubtitle').then((module) => ({ default: module.UiSubtitleControls }))
    )
  },
  {
    name: 'uiList',
    component: lazy(() =>
      import('../../EditorComponents/uiList').then((module) => ({ default: module.UiListControls }))
    )
  },
  {
    name: 'uiCompare',
    component: lazy(() =>
      import('../../EditorComponents/uiCompare').then((module) => ({ default: module.UiCompareControls }))
    )
  },
  {
    name: 'uiIncrease',
    component: lazy(() =>
      import('../../EditorComponents/uiIncrease').then((module) => ({ default: module.UiIncreaseControls }))
    )
  },
  {
    name: 'uiMetric',
    component: lazy(() =>
      import('../../EditorComponents/uiMetric').then((module) => ({ default: module.UiMetricControls }))
    )
  },
  {
    name: 'uiNote',
    component: lazy(() =>
      import('../../EditorComponents/uiNote').then((module) => ({ default: module.UiNoteControls }))
    )
  }
])

const PropsPanel = ({ type, selectedProps, onUpdate }: PropsPanelProps) => {
  const [propsState, setPropsState] = useState(selectedProps)
  const activeInputRef = useRef<HTMLInputElement | HTMLTextAreaElement | null>(null)
  const Component = componentControlsRegistry[type]
  useEffect(() => {
    setPropsState(selectedProps)
  }, [selectedProps])

  useEffect(() => {
    if (activeInputRef.current) {
      activeInputRef.current.focus()
    }
  }, [activeInputRef])

  if (!propsState) return null
  return <div className={style.params}>{Component && <Component object={selectedProps} updateObject={onUpdate} />}</div>
}

export default PropsPanel
